'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import I18n from 'I18n';
import { HEFFALUMP } from 'visitor-ui-component-library/constants/WidgetColors';
import { ChatWidgetLocaleContextConsumer } from '../ChatWidgetLocaleContext';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGNewThread from 'visitor-ui-component-library-icons/icons/SVGNewThread';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ThreadsCardTitle = styled.div.withConfig({
  displayName: "KnowledgeBaseThreadListHeader__ThreadsCardTitle",
  componentId: "ri5fuk-0"
})(["padding:10px 20px;display:flex;justify-content:space-between;align-items:center;flex-direction:row;"]);
export const CardTitleText = styled.h2.withConfig({
  displayName: "KnowledgeBaseThreadListHeader__CardTitleText",
  componentId: "ri5fuk-1"
})(["font-weight:normal;font-size:16px;margin-bottom:0;"]);
export const CardSubTitleText = styled.p.withConfig({
  displayName: "KnowledgeBaseThreadListHeader__CardSubTitleText",
  componentId: "ri5fuk-2"
})(["font-size:12px;margin-bottom:0;"]);
export const NewThreadIconButton = styled(VizExIconButton).withConfig({
  displayName: "KnowledgeBaseThreadListHeader__NewThreadIconButton",
  componentId: "ri5fuk-3"
})(["transition:opacity 0.2s ease-in-out;&:hover:enabled{opacity:0.8;background-color:transparent !important;}"]);
export const NewThreadIcon = styled(VizExIcon).withConfig({
  displayName: "KnowledgeBaseThreadListHeader__NewThreadIcon",
  componentId: "ri5fuk-4"
})(["margin-left:3px;"]);

/**
 * @deprecated
 */
const KnowledgeBaseThreadListHeader = ({
  createNewThread,
  typicalResponseTimeMessage
}) => {
  return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
    children: locale => /*#__PURE__*/_jsxs(ThreadsCardTitle, {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(CardTitleText, {
          children: I18n.text('conversations-visitor-experience-components.visitorWidget.threadListCard.YourChats', {
            locale
          })
        }), /*#__PURE__*/_jsx(CardSubTitleText, {
          "data-test-type": "timestamp",
          children: typicalResponseTimeMessage
        })]
      }), /*#__PURE__*/_jsx(NewThreadIconButton, {
        onClick: createNewThread,
        "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.createNewThread', {
          locale
        }),
        use: "transparent-on-background",
        children: /*#__PURE__*/_jsx(NewThreadIcon, {
          icon: /*#__PURE__*/_jsx(SVGNewThread, {
            style: {
              height: '36px',
              width: '26px'
            }
          })
        })
      })]
    })
  });
};
KnowledgeBaseThreadListHeader.displayName = 'KnowledgeBaseThreadListHeader';
KnowledgeBaseThreadListHeader.propTypes = {
  createNewThread: PropTypes.func,
  typicalResponseTimeMessage: PropTypes.string.isRequired
};
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
KnowledgeBaseThreadListHeader.defaultProps = {
  accentColor: HEFFALUMP,
  createNewThread: () => {},
  typicalResponseTimeMessage: ''
};
export default KnowledgeBaseThreadListHeader;